<template>
  <div class="message-wrap">
    <div class="card">
      <div class="card-body">
        <div class="chat-message" ref="msgBox">
          <!-- 加载更多按钮 -->
          <div class="more-btn-wrap more-btn-wrap-top" v-if="loadMoreBtnTop">
            <div class="more-btn" @click="handleLoadMore('top')">加载更多</div>
          </div>
          <!-- 正在加載... -->
          <div class="loading-more load-top" v-if="initLoading || topLoading">Loading...</div>
          <!-- 沒有更多了 -->
          <div
              v-for="msg in messages"
              :key="msg.message_id"
              :class="['d-flex', 'mb-4', 'msg-item', directionClass(msg.direction)]"
              :data-msgid="msg.message_id"
          >
            <div class="chat-body p-3 z-depth-1" :class="getMsgStatusClass(msg.status)">
              <div class="header">
                <strong class="primary-font">{{ msg.from.name }}</strong>
                <small class="pull-right">
                  &nbsp;<i class="far fa-clock"></i>&nbsp;{{ filterTime(msg.time) }}
                </small>
                <span class="float-right" v-if="canReply(msg)">
                   <mdb-dropdown>
                    <mdb-dropdown-toggle slot="toggle"><svg t="1717570413957" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5042" width="48" height="48"><path d="M478.08 801.92L71.04 394.624a48 48 0 0 1 67.84-67.84L512 700.096l373.376-373.312a48 48 0 0 1 67.84 67.84L545.92 801.92a48 48 0 0 1-67.84 0z" fill="#666666" p-id="5043"></path></svg></mdb-dropdown-toggle>
                    <mdb-dropdown-menu class="z-depth-1" aria-labelledby="dropdownMenuButton" :right="true">
                      <mdb-dropdown-item @click.prevent="setReplyMsg(msg)">Reply</mdb-dropdown-item>
                    </mdb-dropdown-menu>
                  </mdb-dropdown>
                </span>
              </div>
              <hr class="w-100"/>
              <!-- 如果为 引用消息 -->
              <div class="chat-body p-2 z-depth-1 commont-body" v-if="msg.quote_msg">
                <div class="header">
                  <strong class="primary-font">{{ getRefFromName(msg.quote_msg) }}</strong>
                  <small class="pull-right">
                    &nbsp;<i class="far fa-clock"></i>&nbsp;{{ filterTime(msg.quote_msg.time) }}
                  </small>
                </div>
                <hr class="w-100 p-0 m-1"/>
                <bubble :type="msg.quote_msg.type" :content="msg.quote_msg.content"></bubble>
              </div>
              <bubble :type="msg.type" :content="msg.content"></bubble>
            </div>
          </div>
          <div class="system-message chat-body z-depth-1" v-if="conversationSessionExpired">
            <p>⚠️你與此聯絡人的對話已經過期，請重新與對方聯繫 ⚠️</p>
          </div>

          <!-- 加载更多按钮 -->
          <div class="more-btn-wrap more-btn-wrap-bot" v-if="loadMoreBtnBot">
            <div class="more-btn" @click="handleLoadMore('bot')">加载更多</div>
          </div>
          <!-- 正在加載 -->
          <div class="loading-more load-bot" v-if="botLoading">Loading...</div>
        </div>
        <div class="chat-ctrl">
          <form @submit.prevent="sendMsg">
            <div class="form-group">
              <hr class="w-100 z-depth-1"/>
              <div class="reply-ref-mgs-wrap z-depth-1" v-if="replyMsg">
                <svg t="1717566697189" class="icon quote-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16221" width="48" height="48"><path d="M384 128c-81.292 0-144.966 22.458-189.254 66.746C150.458 239.034 128 302.708 128 384l0 512 320 0L448 384l-192 0c0-46.112 9.844-79.332 29.254-98.746C304.668 265.844 337.888 256 384 256" p-id="16222"></path><path d="M832 128c-81.292 0-144.966 22.458-189.254 66.746C598.458 239.034 576 302.708 576 384l0 512 320 0L896 384l-192 0c0-46.112 9.844-79.332 29.254-98.746C752.668 265.844 785.888 256 832 256" p-id="16223"></path></svg>
                <div class="chat-body p-2 z-depth-1 commont-body">
                  <div class="msg-body">
                    <div class="header">
                      <strong class="primary-font">{{ getRefFromName(replyMsg) }}</strong>
                      <small class="pull-right">
                        &nbsp;<i class="far fa-clock"></i>&nbsp;{{ filterTime(replyMsg.time) }}
                      </small>
                    </div>
                    <hr class="w-100 m-0"/>
                    <bubble :type="replyMsg.type" :content="replyMsg.content"></bubble>
                  </div>
                </div>
                <a class="close-btn" @click.prevent="clearReplyMsg"><svg t="1717566721870" class="icon" viewBox="0 0 1102 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17212" width="48" height="48"><path d="M701.597538 511.842462l366.119385-366.119385a57.974154 57.974154 0 0 0 0-82.077539l-41.038769-41.038769a57.974154 57.974154 0 0 0-82.077539 0L578.481231 388.726154 212.283077 22.528a57.974154 57.974154 0 0 0-82.077539 0l-41.117538 41.117538a57.974154 57.974154 0 0 0 0 82.077539l366.119385 366.119385-366.119385 366.119384a58.131692 58.131692 0 0 0 0 82.156308l41.038769 41.038769a57.974154 57.974154 0 0 0 82.077539 0l366.119384-366.119385 366.119385 366.119385a57.974154 57.974154 0 0 0 82.077538 0l41.03877-41.038769a58.131692 58.131692 0 0 0 0-82.156308L701.597538 511.842462z" fill="#1E2330" p-id="17213"></path></svg></a>
              </div>
              <div class="textarea-wrap">
                <div class="md-form inner-shadow">
                  <textarea rows="4" class="md-textarea"
                            placeholder="Type your message here..."
                            :disabled="loadingFlag" v-model="content"></textarea>
                </div>
                <stt-button @transcript="handleSpeech"></stt-button>
              </div>
            </div>
            <div class="d-flex justify-content-end align-items-center">
              <mdb-dropdown v-if="!loadingFlag" class="template-btn" title="Send Template">
                <mdb-dropdown-toggle slot="toggle" class="btn-outline-secondary">
                  <i class="fas fa-caret-square-down fa-lg"></i>
                </mdb-dropdown-toggle>
                <mdb-dropdown-menu class="z-depth-1" aria-labelledby="dropdownMenuButton" :dropup="true">
                  <mdb-dropdown-item @click.stop="sendTemplate(item.name)" v-for="item in templateOptions">{{ item.title }}</mdb-dropdown-item>
                </mdb-dropdown-menu>
              </mdb-dropdown>

              <span v-if="uploadError && uploadError.length > 0" class="error">{{ uploadError }}</span>
              <div title="Send File/Image/Video">
                <upload
                    v-show="!loadingFlag"
                    :options="UploadOption"
                    @added="handleFileSelected"
                    @uploaded="handleFileUploaded"
                    @error="handleUploadError"
                    @complete="handleUploadComplete"
                ></upload>
              </div>

              <button class="btn btn-info" title="Quick Replies" type="button" @click="handleQuickRepliesShow">
                <i class="fas fa-reply"></i>
              </button>

              <button v-if="!loadingFlag" title="Send" class="btn btn-success" type="submit">
                <i class="fas fa-paper-plane"></i>
              </button>

              <div v-if="loadingFlag" class="spinner-border text-info" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <quick-replies :show="showQuickReplies"
                   @selected="handleQuickReliesText"
                   @close="handleQuickRepliesClose"></quick-replies>
  </div>
</template>
<script>
import STTButton from "../components/STTButton";
import quickReplise from "../components/QuicReplies";
import mdbDropdown from "mdbvue/src/components/Components/Dropdown";
import mdbDropdownToggle from "mdbvue/src/components/Components/DropdownToggle";
import mdbDropdownMenu from "mdbvue/src/components/Components/DropdownMenu";
import mdbDropdownItem from "mdbvue/src/components/Components/DropdownItem";
import mdbTextarea from "mdbvue/src/components/Forms/MdTextarea";
import dayjs from "dayjs";
import MsgService from "../Services/MsgService";
import WSService from "../Services/WSService";
import Bubble from "../components/Bubble";
import VuePlupload from "../components/vue-plupload";
import badgeService from "@/Services/badgeService";

const {EventBus} = require("../Bus.js");

export default {
  components: {
    bubble: Bubble,
    upload: VuePlupload,
    mdbTextarea,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbDropdownItem,
    "stt-button": STTButton,
    "quick-replies": quickReplise,
  },
  data() {
    return {
      templateOptions: [],
      conversationSessionExpired: false,
      showQuickReplies: false,
      uploadError: '',
      fromId: 0,
      content: "",
      loadingFlag: false,
      initLoading: true,
      loadMoreBtnTop: false,
      loadMoreBtnBot: false,
      botLoading: false,
      topLoading: false,
      messages: [],
      next_id: 0,
      prev_id: 0,
      replyMsg: null,
      UploadOption: {
        filters: [
          {title: "Image", extensions: "jpg,png,jpeg,gif"},
          {title: "Video", extensions: "mp4,mov"},
          {title: "File", extensions: "pdf,zip,docx,doc,xls,xlsx,ppt,pptx"}
        ],
        multi_selection: true
      }
    };
  },
  watch: {
    next_id(newVal) {
      if (newVal != 0) {
        this.loadMoreBtnTop = true;
      } else {
        this.loadMoreBtnTop = false;
      }
    },
    prev_id(newVal) {
      if (newVal != 0) {
        this.loadMoreBtnBot = true;
      } else {
        this.loadMoreBtnBot = false;
      }
    },

    $route(to, from) {
      this.fromId = this.$route.params.uid;
      this.fetchData();
    }
  },
  methods: {
    fetchTemplate() {
      let msg = new MsgService();
      return msg.templateList()
        .then(data => {
          this.templateOptions = data;
        })
    },
    sendTemplate(template_id) {
      if (this.fromId) {
        let msg = new MsgService();
        this.loadingFlag = true;
        return msg.sendTemplate(this.fromId, template_id)
            .finally(() => {
              this.loadingFlag = false;
            })
      }
    },
    getMsgStatusClass(status) {
      switch (status) {
        case 2:
          return "failed";
        case 3:
          return "success";
        default:
          return "sent";
      }
    },
    handleSpeech(text) {
      this.content += text;
    },
    getRefFromName(msg) {
      if (msg.from && msg.from.name) {
        return msg.from.name;
      }
      return ``;
    },
    // 加载更多按钮回调
    handleLoadMore(flag) {
      if (flag == "top") {
        // console.log("顶部加载更多");
        this.loadMoreBtnTop = false;
        this.topLoading = true;
        // 开始加载更多数据
        this.fetchMsg(flag)
      } else {
        // console.log("底部加载更多");
        this.loadMoreBtnBot = false;
        this.botLoading = true;
        // 开始加载更多数据
        this.fetchMsg(flag)
      }
    },
    // 當入口為聊天記錄的時候，滾動條定位到對應位置
    initScroll(msg_id) {
      // console.log('当前滚动条位置ID: ', msg_id)
      // console.log('当前数组长度: ', this.messages.length)
      let list = this.messages;
      list.forEach((item, index) => {
        if (item.message_id == msg_id) {
          // console.log('当前滚动条位置index: ', item)
          this.$nextTick(() => {
            let msgBox = document.querySelector(".chat-message");
            let target = msgBox.childNodes[index + 1];
            if (!!target) {
              msgBox.scrollTop = target.offsetTop + target.offsetHeight;
              return;
            }
          });
        }
      });
    },
    directionClass(direction) {
      return direction == "incoming"
          ? "justify-content-start"
          : "justify-content-end";
    },
    sendSourceMessage(type, content) {
      this.loadingFlag = true;

      let msg = new MsgService();

      if (this.replyMsg) {
        content = {
          ...content,
          reply_to: this.replyMsg?.src_id,
        }
      }

      return msg
          .Send(this.fromId, type, content)
          .catch(err => {
            console.warn(err);
          })
          .finally(() => {
            this.content = "";
            this.loadingFlag = false;
            if (this.replyMsg) {
              this.replyMsg = null;
            }
          });
    },
    sendMsg() {
      if (this.content.length <= 0) {
        return;
      }

      this.sendSourceMessage("text", {
        text: this.content,
      });
    },
    filterTime(time) {
      let date = dayjs.unix(time);
      let after = date.format("YYYY-MM-DD");
      let today = dayjs(new Date())
          .hour(0)
          .minute(0)
          .second(0);
      let diff = date.diff(today, "days", true);
      if (diff < 0 && diff > -1) {
        after = "Yesterday";
      }
      if (diff > 0) {
        after = "Today";
      }
      return date.format("HH:mm A") + " | " + after;
    },
    // 翻页fetch数据
    fetchMsg(dir) {
      if (!this.fromId) return;

      let from = this.fromId;
      let {next_id, prev_id} = this;

      if (dir == 'top') {
        prev_id = 0
      } else {
        next_id = 0
      }

      let msg = new MsgService();
      return msg
          .getMessages(from, next_id, prev_id, 0)
          .then(data => {
            // console.log("翻页的数据:", data);

            let {list, next_id = 0, prev_id = 0} = data;

            let renderList = list.map(item => {
              if (item.from.uid == this.fromId) {
                item.direction = "incoming";
              } else {
                item.direction = "outgoing";
              }
              return item;
            });

            if (dir == 'top') {
              renderList.reverse();
              this.next_id = next_id;
              this.prev_id = prev_id || this.prev_id
              this.messages = renderList.concat(this.messages)
              this.initScroll(renderList[renderList.length - 2].message_id)

            } else {
              this.prev_id = prev_id;
              this.next_id = next_id || this.next_id

              this.messages = this.messages.concat(renderList)
              // this.initScroll(renderList[ 1 ].message_id)

            }
          })
          .finally(() => {
            // console.log('关掉loading')
            if (dir == 'top') {
              this.topLoading = false;
            } else {
              this.botLoading = false;
            }
          });
    },
    // 初始化數據
    fetchData() {
      if (!this.fromId) return;
      let msg = new MsgService();
      let from = this.fromId;
      let msg_id = this.currentMsgId || 0;

      return new Promise((resolve, reject) => {
        msg
            .getMessages(from, 0, 0, msg_id)
            .then(data => {
              // console.log("组件初始化数据:", data);

              let {list, next_id = 0, prev_id = 0} = data;
              this.next_id = next_id;
              this.prev_id = prev_id;

              let msg = list.map(item => {
                if (item.from.uid == this.fromId) {
                  item.direction = "incoming";
                } else {
                  item.direction = "outgoing";
                }
                return item;
              });
              msg.reverse();
              this.messages = msg;

              // 数据初始化，滚动条位置
              if (!!this.currentMsgId) {
                this.initScroll(this.currentMsgId);
              } else {
                this.$nextTick(() => {
                  let box = document.querySelector(".chat-message");
                  box.scrollTop = box.scrollHeight;
                });
              }
              resolve();
            })
            .finally(() => {
              this.initLoading = false;

              if (this.messages && this.messages.length > 0) {
                let last = this.messages[this.messages.length - 1];
                // expire 24h
                if (last.time + 86400 <= dayjs().unix()) {
                  this.conversationSessionExpired = true;
                }
              }
            });
      });
    },
    // ws.e.heartBeat的数据请求
    WS_updateMsg() {
      if (!this.fromId) return;
      let msg = new MsgService();
      let from = this.fromId;

      msg
          .getMessages(from, 0, 0, 0)
          .then(data => {

            let {list, next_id = 0, prev_id = 0} = data;
            this.next_id = next_id;
            this.prev_id = prev_id;

            let msg = list.map(item => {
              if (item.from.uid == this.fromId) {
                item.direction = "incoming";
              } else {
                item.direction = "outgoing";
              }
              return item;
            });
            msg.reverse();
            this.messages = msg;

            // 滚动条位置
            this.$nextTick(() => {
              let box = document.querySelector(".chat-message");
              box.scrollTop = box.scrollHeight;
            });
          })
    },

    handleFileSelected(uploader, files) {
      this.uploadError = '';
      this.loadingFlag = true;
      uploader.start();
    },

    matchUploadType(file) {
      const imageRule = /image/i;
      const videoRule = /video/i;

      if (imageRule.test(file.mime)) {
        return 'image';
      }

      if (videoRule.test(file.mime)) {
        return 'video';
      }

      return 'file';
    },

    handleFileUploaded(uploader, file, result) {
      let resp = result.response;
      let json = JSON.parse(resp);
      if (json && json.status == 1) {
        const type = this.matchUploadType(json.data);
        this.sendSourceMessage(type, {
          url: json.data.url,
          filename: json.data.name,
        });
        return;
      }
      const error = json.error || {};
      console.error(error);
      const msg = error.msg;
      const validate = error.validate;
      if (validate) {
        this.uploadError = validate.file[0];
        return;
      }
      if (msg) {
        this.uploadError = msg;
      }
    },

    handleUploadComplete(uploader, files) {
      this.loadingFlag = false;
      uploader.refresh();
    },

    handleUploadError(uploader, err) {
      console.error(err);
      const file = err.file || {};
      const filename = file.name || '';
      const msg = err.message;
      this.uploadError = `${filename} ${msg}`;
      this.loadingFlag = false;
    },

    handleUpdateMsg(e) {
      console.log('new msg', e)
      let msg = e.data;
      switch (e.event) {
        case WSService.Event.Msg.InComing:
        case WSService.Event.Msg.OutGoing:
          if (msg.from.uid == this.fromId || msg.to.uid == this.fromId) {
            msg.direction = e.event.replace(/msg\./, "");
            const existIndex = Array.from(this.messages).findIndex((row) => {
              return row.message_id === msg.message_id;
            });
            if (existIndex > -1) {
              this.$set(this.messages, existIndex, {...msg});
            } else {
              this.messages.push({...msg});
            }

            this.$nextTick(() => {
              let box = document.querySelector(".chat-message");
              box.scrollTop = box.scrollHeight;
            });
          }
          break;
        case Event.Heartbeat:
          this.WS_updateMsg();
          break;
      }
    },

    read_msg() {
      let msg = new MsgService();
      msg.read(this.fromId);
      badgeService.remove(this.fromId);
    },
    // 函数防抖
    debounce(func, wait) {
      let timeout;
      return function () {
        let context = this;
        let args = arguments;
        if (timeout) clearTimeout(timeout);
        let callNow = !timeout;
        timeout = setTimeout(() => {
          timeout = null;
        }, wait);
        if (callNow) func.apply(context, args);
      };
    },
    handleQuickRepliesClose() {
      this.showQuickReplies = false;
    },
    handleQuickRepliesShow() {
      this.showQuickReplies = true;
    },
    handleQuickReliesText(text) {
      this.content = text;
      this.handleQuickRepliesClose();
    },
    canReply(msg) {
      return /^wamid/i.test(msg.src_id || '') && (msg.content?.chat_msg_type != 'reaction');
    },
    setReplyMsg(msg) {
      this.replyMsg = {...msg};
    },
    clearReplyMsg() {
      this.replyMsg = null;
    }
  },
  mounted() {
    this.fromId = this.$route.params.uid;
    this.currentMsgId = this.$route.params.msg_id;

    this.fetchData();
    this.read_msg();
    this.fetchTemplate();

    EventBus.onNewMessage(this.handleUpdateMsg);
  },
  beforeDestroy() {
    EventBus.offNewMessage(this.handleUpdateMsg);
  },
};
</script>
<style lang="scss">
.message-wrap .template-btn {
  margin: 0.375rem;

  .dropdown-toggle.btn {
    padding: 0.7rem 2rem;
    font-size: 0.81rem;
  }
}

.inner-shadow {
  margin: 0;

  textarea.md-textarea {
    width: 100%;
    box-sizing: border-box;
    padding: 0.5em;
    line-height: 1.5;
  }
}
</style>
